import { ICreateAndUpdateGovernmentShip } from "../../../types/govenmentShip.interface";
import customAxios from "../../customAxios";
import { CREATE_GOVERNMENT_SHIP } from "../../routes";

const createSuperAgent = async (formData: ICreateAndUpdateGovernmentShip) => {
  try {
    return (
      await customAxios.post(CREATE_GOVERNMENT_SHIP, {
        province: formData.province?._id,
        phoneNumber: formData.phoneNumber,
        name: formData.name,
      })
    ).data;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

export default createSuperAgent;
